import { Navigate, useLocation } from 'react-router';
import type { Permission } from '@aurea/contracts';
import { useAuth } from '../lib/auth';

/**
 * Защита маршрута. Права проверяются и здесь, и на сервере — клиентская
 * проверка нужна только чтобы не показывать пункт меню, который всё равно
 * вернёт 403. Решение о доступе принимает API.
 */
export function RequireAuth({
  children,
  permission,
}: {
  children: React.ReactNode;
  /** Одно право или несколько: доступ даёт любое из них. */
  permission?: Permission | readonly Permission[];
}) {
  const { user, isLoading, can } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-full items-center justify-center text-[13px] text-ink-faint">
        Загружаем…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  const required = permission ? (Array.isArray(permission) ? permission : [permission]) : [];

  if (required.length > 0 && !required.some((item) => can(item))) {
    return (
      <div className="flex min-h-full items-center justify-center px-4">
        <div className="max-w-[420px] text-center">
          <div className="mb-3 text-[40px] leading-none">🔒</div>
          <h1 className="mb-2 text-lg font-extrabold">Раздел недоступен</h1>
          <p className="text-[13px] leading-relaxed text-ink-faint">
            У вашей роли нет прав на эту страницу. Если доступ нужен — попросите администратора его
            выдать.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
